;"use strict";

let NS = {
    w: window,
    d: document,


    image_with_tooltips: {
        bg: function (){
            if($(window).width() >= 1024){
                $('.desc_1_2').css({
                    "background-position": '0px 8px'
                });
            }
            if($(window).width() >= 768 && $(window).width() < 1024){
                $('.desc_1_2').css({
                    "background-position": '0px 18px'
                });
            }
            if($(window).width() >= 768 && arguments.length){
                for(let i = 0; i < arguments.length; i++){
                    arguments[i].css({
                        "background-position": '0px ' + arguments[i].find('.title_block').height() + 'px'
                    });
                }
            }
        },
        anim: {
            math_max__width_mobile: function (element){
                let arr = [],
                    max = 0;
                element.each(function (i, elem){
                    arr.push($(elem).width());
                });
                if($(window).width() >= 768) {
                    element.removeAttr('style');
                }
                else{
                    max = Math.max.apply(Math, arr);
                    element.css({
                        'width': max + 'px'
                    })
                }
            },
            title_block: function (){
                $(".image_with_tooltips .title_block").each(function (i, elem){
                    $(elem).on("click", function (e){
                        if($(window).width() >= 768){
                            $(this).toggleClass("active");
                            $(this).next('.description').toggleClass("active");
                        }else{
                            if($(this).hasClass("active")){
                                $(this).removeClass("active");
                                $(".text_inner__mobile").html(' ').removeClass('active');
                                $(".img_inner").removeClass("animate_hidden");
                            }else{
                                $(".image_with_tooltips .title_block").removeClass("active");

                                $(this).addClass("active");
                                $(".text_inner__mobile").addClass('active').html($(this).next('.description').html());
                                $(".img_inner").addClass("animate_hidden");
                            }
                            //$(this).toggleClass("active");
                            //$(".text_inner__mobile").html(' ').toggle().toggleClass('active');
                            //$(this).closest(".inner").find(".text_inner__mobile").html($(this).next('.description').html());
                            //$(".img_inner").toggleClass("animate_hidden");
                        }
                    });
                });
            },
            removeClasses: function (){
                $(".image_with_tooltips .title_block").removeClass('active');
                $(".image_with_tooltips .text_inner__mobile").removeClass('active');
                $(".image_with_tooltips .img_inner").removeClass('animate_hidden');
                $(".image_with_tooltips .description").removeClass('active');
            }
        }
    },


    init: function (){
        //this.image_with_tooltips.anim.math_max__width_mobile($(".image_with_tooltips .in"));
        this.image_with_tooltips.anim.title_block();
    }
}

$(window).on("load", function (){

    NS.init();


    NS.image_with_tooltips.bg($(".desc_1_1"), $(".desc_3_1"));

    $(".js_open_popup").on("click", function (e){
        $(".popup_out_of_stock").toggleClass("active");
        $("body").toggleClass("ov_h");
    });

    $(".popup_out_of_stock_close").on("click", function (e){
        $(".js_open_popup").trigger("click");
    });

    $(window).on('resize', function (){
        NS.image_with_tooltips.anim.removeClasses();
        NS.image_with_tooltips.bg($(".desc_1_1"), $(".desc_3_1"));
    });





    /**
     * AJAX Submit Shopify Contact Forms
     *
     * @param {array} contact_forms - array of form elements to add submit event listeners too
     */
    function ajaxForms_contact(contact_forms){
        // Allow the passing of forms array, default to all .contact-form elements
        contact_forms = typeof contact_forms !== 'undefined' ? contact_forms : $('.contact-form').toArray();

        // Loop forms and add event listener
        $.each(contact_forms, function(i, form) {
            var formData = {
                form: $(this),
                formId: $(this).attr('id'),
                action: $(this).attr('action'),
                successMsg: "<p class='note note--success'>Thanks for contacting us. We'll get back to you as soon as possible.</p>"
            };

            // Add submit event listener
            $(formData.form).on('submit', function (e) {
                // Init AJAX
                $.ajax({
                    type: 'POST',
                    async: true,
                    url: formData.action,
                    data: formData.form.serialize(),
                    beforeSend: function() {
                        formData.form.addClass('sending');
                    },
                    error: function(data) {
                        console.log('error: ',data);
                        formData.form.addClass('error');

                        // 429 error - too many requests
                        if(data.status == 429) {
                            // Allow for default redirect to challenge form, do not force
                            console.log('Allow default window redirection for challenge');
                        }else {
                            e.preventDefault(); // if fields are empty, paste errors
                            $(formData.form).before("<div class='errors'>" + response.statusText + "</div>");
                        }
                    },
                    success: function (data) {
                        e.preventDefault(); // prevent default if successful and challenge is not needed
                        console.log('success: ',data);
                        formData.form.addClass('success');
                        formData.form.fadeOut(300, function(){
                            formData.form.closest('div').append(formData.successMsg);
                        });
                    }
                }); // close ajax
            }); // close 'submit' event
        }); // close loop
    }

// Init function
    ajaxForms_contact();


    if(location.href.indexOf("#contact_form") > -1){
        $(".js_open_popup").text("Form Was Sent");
        $(".js_open_popup").addClass("disabled");
    }





});